import { APP_URLS } from 'constants/urls';
import { NEW } from '@lib/enums/common';
import { DEFAULT_LIST_PARAMS } from '@lib/enums/urls';
import { BreadCrumbsOptions } from './types';
import getDashboardHomeItem from './dashboardHomeItem';

export default function getAssetsBreadcrumbMap({
  pathname,
  t,
  entity,
}: BreadCrumbsOptions) {
  const dashboardHomeItem = getDashboardHomeItem({ t });
  const assetsItem = {
    label: t('assets'),
    path: APP_URLS.dashboard.assets.index.getPathWithQuery(),
  };

  return [
    {
      condition: APP_URLS.dashboard.assets.index.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        {
          label: t('assets'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.assets.categories.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        assetsItem,
        {
          label: t('categories'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.assets.add.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        assetsItem,
        {
          label: t('add-new-asset'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.assets.edit.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.id}`,
        },
      }),
      data: [
        dashboardHomeItem,
        assetsItem,
        {
          label: entity?.name,
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.assets.view.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.id}`,
        },
      }),
      data: [
        dashboardHomeItem,
        assetsItem,
        {
          label: entity?.name,
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.assets.nomenclature.isTheSameUrlAs(
        pathname,
        {
          pathParts: {
            id: `${entity?.id}`,
          },
        },
      ),
      data: [
        dashboardHomeItem,
        assetsItem,
        {
          label: t('view-asset'),
          path: APP_URLS.dashboard.assets.view.getDynamicPath({
            pathParts: {
              id: `${entity?.id}`,
            },
          }),
        },
        {
          label: t('nomenclature'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.assets.counter.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.id}`,
        },
      }),
      data: [
        dashboardHomeItem,
        assetsItem,
        {
          label: t('view-asset'),
          path: APP_URLS.dashboard.assets.view.getDynamicPath({
            pathParts: {
              id: `${entity?.id}`,
            },
          }),
        },
        {
          label: t('counters'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.assets.counters.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.id}`,
        },
      }),
      data: [
        dashboardHomeItem,
        assetsItem,
        {
          label: t('counter-monitoring'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.assets.documentation.isTheSameUrlAs(
        pathname,
        {
          pathParts: {
            id: `${entity?.id}`,
          },
        },
      ),
      data: [
        dashboardHomeItem,
        assetsItem,
        {
          label: t('view-asset'),
          path: APP_URLS.dashboard.assets.view.getDynamicPath({
            pathParts: {
              id: `${entity?.id}`,
            },
          }),
        },
        {
          label: t('documentation'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.assets.interventions.isTheSameUrlAs(
        pathname,
        {
          pathParts: {
            id: `${entity?.id}`,
          },
        },
      ),
      data: [
        dashboardHomeItem,
        assetsItem,
        {
          label: t('view-asset'),
          path: APP_URLS.dashboard.assets.view.getDynamicPath({
            pathParts: {
              id: `${entity?.id}`,
            },
          }),
        },
        {
          label: t('interventions'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.assets.document.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.assetId}`,
          documentId: `${entity?.id}`,
        },
      }),
      data: [
        dashboardHomeItem,
        assetsItem,
        {
          label: t('view-asset'),
          path: APP_URLS.dashboard.assets.view.getDynamicPath({
            pathParts: {
              id: `${entity?.assetId}`,
            },
          }),
        },
        {
          label: t('documentation'),
          path: APP_URLS.dashboard.assets.documentation.getDynamicPath({
            pathParts: {
              id: `${entity?.assetId}`,
            },
            params: {
              ...DEFAULT_LIST_PARAMS,
            },
          }),
        },
        {
          label: t('edit-document'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.assets.document.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.assetId}`,
          documentId: NEW,
        },
      }),
      data: [
        dashboardHomeItem,
        assetsItem,
        {
          label: t('view-asset'),
          path: APP_URLS.dashboard.assets.view.getDynamicPath({
            pathParts: {
              id: `${entity?.assetId}`,
            },
          }),
        },
        {
          label: t('documentation'),
          path: APP_URLS.dashboard.assets.documentation.getDynamicPath({
            pathParts: {
              id: `${entity?.assetId}`,
            },
            params: {
              ...DEFAULT_LIST_PARAMS,
            },
          }),
        },
        {
          label: t('upload-document'),
        },
      ],
    },
  ];
}
